import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCheck = function SvgCheck(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M21.09 3.486L8.567 16.045l-5.657-5.672c-.646-.648-1.778-.648-2.424 0-.647.648-.647 1.783 0 2.43l6.869 6.888c.323.324.808.486 1.212.486.404 0 .889-.162 1.212-.486L23.515 5.917c.647-.648.647-1.783 0-2.43-.727-.649-1.778-.649-2.424 0z"
  }));
};

export default SvgCheck;